import { styled } from '@mui/material';
import { UIColors } from '../../../../constants/UIConstants';
import { X } from 'react-feather';

export const StyledXIcon = styled(X)`
  color: ${UIColors.primary.darkBlue};
`;
